import './sub-navigation.scss';
import React from 'react';
import { T } from 'shared/helper/translate';
import SubNavigationItems from './SubNavigationItems';
var SubNavigation = function SubNavigation(_ref) {
  var items = _ref.items,
    user = _ref.user;
  return /*#__PURE__*/React.createElement("div", {
    className: "sub-navigation"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-75 mx-auto d-none d-md-block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row sub-nav-list-wrapper mx-0 mb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-4 d-none d-lg-block ps-0"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Welcome back"
  }), ", ", /*#__PURE__*/React.createElement("span", {
    className: "fw-bold"
  }, user.fullName)), /*#__PURE__*/React.createElement("div", {
    className: "col col-lg-8 pe-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "navbar navbar-expand-lg p-0 mb-3"
  }, /*#__PURE__*/React.createElement(SubNavigationItems, {
    className: "nav navbar-nav w-100 mt-0 justify-content-end",
    items: items,
    childComponentRenderer: SubNavigationItems
  }))))));
};
export default SubNavigation;